import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl   
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getBalance(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/account`);
  }

  getLastTransactions(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/transaction/last`);
  }
}
